
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-gb/use-cases/personal-finances",
      function () {
        return require("private-next-pages/en-gb/use-cases/personal-finances.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-gb/use-cases/personal-finances"])
      });
    }
  